import app from './app/store';
import common from './common/store';
import session from './session/store';
import authorisation from './authorisation/store';
import crossTenant from './cross-tenant/store';
import clients from './clients/store';
import risks from './risks/store';
import excursions from './excursions/store';
import ahaFeedback from './aha-feedback/store';
import hubMigration from './hub-migration/store';
import hubIntegration from './hub-integration/store';

const modules = {
  app,
  common,
  session,
  authorisation,
  'cross-tenant': crossTenant,
  clients,
  risks,
  excursions,
  ahaFeedback,
  'hub-migration': hubMigration,
  'hub-integration': hubIntegration
};

export default modules;
